@if (!enabled()) {
  <p class="text-slate-500 py-6">Guarda la empresa para habilitar firmas de correo.</p>
} @else {
  <div class="flex items-center justify-between mt-4 mb-4 gap-4 flex-wrap">
    <div>
      <h3 class="text-lg font-semibold text-slate-900">Firmas de correo</h3>
      <p class="text-sm text-slate-500">Plantillas reutilizables para firmar comunicados y correos salientes.</p>
    </div>
    <p-button label="Nueva firma" icon="pi pi-plus" (onClick)="newSignature()" />
  </div>

  <div class="flex gap-3 p-4 rounded-lg bg-slate-50 border border-slate-200 mb-6">
    <i class="pi pi-info-circle text-sky-600 mt-0.5 shrink-0" aria-hidden="true"></i>
    <div class="text-sm text-slate-700">
      <p class="font-medium text-slate-800 mb-1">¿Cómo funcionan las firmas?</p>
      <p>
        Elige un layout precocinado y personaliza los datos, o crea una desde cero.
        Las firmas se guardan como plantilla <span class="font-medium">Handlebars</span>:
        nombre, cargo, teléfono, email y foto se rellenan con el usuario que envía el correo
        (<span class="font-mono text-[11px]">{{ '{{userFullName}}' }}</span>,
        <span class="font-mono text-[11px]">{{ '{{userJobTitle}}' }}</span>,
        <span class="font-mono text-[11px]">{{ '{{userPhone}}' }}</span>,
        <span class="font-mono text-[11px]">{{ '{{userEmail}}' }}</span>,
        <span class="font-mono text-[11px]">{{ '{{userPhotoUrl}}' }}</span>).
      </p>
    </div>
  </div>

  <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-slate-50 border-b border-slate-200">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Firma</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider hidden sm:table-cell">Layout</th>
            <th class="px-6 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider hidden md:table-cell">Vista previa</th>
            <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">Acciones</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-slate-200">
          @if (signatures().length === 0) {
            <tr>
              <td class="px-6 py-8 text-center text-sm text-slate-500" colspan="4">
                Aún no hay firmas. Crea una con un layout precocinado o desde cero.
              </td>
            </tr>
          } @else {
            @for (item of signatures(); track item.id) {
              <tr class="hover:bg-slate-50 transition-colors">
                <td class="px-6 py-4">
                  <div class="flex items-center gap-3 min-w-0">
                    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sky-700">
                      <i class="pi pi-pen-to-square"></i>
                    </span>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ item.name }}</div>
                      <div class="text-xs text-slate-500 sm:hidden">{{ layoutLabel(item.layoutId) }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap hidden sm:table-cell">
                  <p-tag class="!text-xs" [value]="layoutLabel(item.layoutId)" severity="info" />
                </td>
                <td class="px-6 py-4 hidden md:table-cell">
                  <div class="signature-preview-body max-w-md max-h-24 overflow-hidden opacity-90 scale-90 origin-left" [innerHTML]="listPreviewHtml(item)"></div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right">
                  <p-button icon="pi pi-copy" [rounded]="true" [text]="true" severity="secondary" pTooltip="Copiar HTML" tooltipPosition="bottom" (onClick)="copyHtml(item)" />
                  <p-button icon="pi pi-pen-to-square" [rounded]="true" [text]="true" severity="secondary" styleClass="hover:!bg-sky-100" (onClick)="startEdit(item)" />
                  <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="openDelete(item)" />
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
}

<!-- Modal crear / editar firma -->
@if (showEditor()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      class="absolute inset-0 bg-black transition-opacity duration-200"
      [class.bg-opacity-40]="editorShown()"
      [class.bg-opacity-0]="!editorShown()"
      (click)="closeEditor()"
    ></div>
    <div
      class="relative bg-white rounded-xl shadow-xl w-full max-w-4xl z-10 transform transition-all duration-200 max-h-[92vh] flex flex-col overflow-hidden"
      [class.opacity-100]="editorShown()"
      [class.opacity-0]="!editorShown()"
      [class.scale-100]="editorShown()"
      [class.scale-95]="!editorShown()"
    >
      <div class="shrink-0 px-6 pt-6 pb-4">
      <div class="flex items-start justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-slate-900">
            {{ editingId() ? 'Editar firma' : 'Nueva firma de correo' }}
          </h3>
          <p class="text-sm text-slate-500 mt-1">
            @if (editorStep() === 'pick-layout') {
              Elige un formato precocinado o empieza desde cero.
            } @else if (showFieldCustomization()) {
              Personaliza los datos del layout seleccionado.
            } @else {
              Edita con el editor visual o el código HTML.
            }
          </p>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (onClick)="closeEditor()" />
      </div>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-6 pb-2">
      @if (editorStep() === 'pick-layout') {
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 pb-4">
          @for (preset of presets; track preset.id) {
            <button
              type="button"
              class="text-left rounded-xl border border-slate-200 bg-white p-4 hover:border-sky-300 hover:bg-sky-50/50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
              (click)="selectLayout(preset.id)"
            >
              <div class="flex items-center gap-3 mb-2">
                <span class="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
                  <i [class]="preset.icon"></i>
                </span>
                <div>
                  <div class="text-sm font-semibold text-slate-900">{{ preset.label }}</div>
                  @if (preset.usesPhoto && preset.usesLogo) {
                    <span class="text-[11px] font-medium text-sky-700">Foto + logo</span>
                  } @else if (preset.usesPhoto) {
                    <span class="text-[11px] font-medium text-sky-700">Con foto</span>
                  } @else if (preset.usesLogo) {
                    <span class="text-[11px] font-medium text-sky-700">Con logo</span>
                  } @else if (preset.usesTextImage) {
                    <span class="text-[11px] font-medium text-sky-700">Texto + imagen</span>
                  }
                  @if (preset.blank) {
                    <span class="text-[11px] font-medium text-sky-700">Libre</span>
                  }
                </div>
              </div>
              <p class="text-xs text-slate-500 leading-relaxed">{{ preset.description }}</p>
            </button>
          }
        </div>
      } @else {
        <div class="space-y-5" [formGroup]="signatureForm">
          <div class="flex flex-wrap items-center gap-3">
            @if (!editingId()) {
              <p-button
                label="Cambiar layout"
                icon="pi pi-arrow-left"
                severity="secondary"
                [text]="true"
                size="small"
                type="button"
                (onClick)="backToLayouts()"
              />
            }
            @if (selectedPreset(); as preset) {
              <p-tag [value]="preset.label" severity="info" class="!text-xs" />
            }
          </div>

          <div class="flex flex-col gap-1 max-w-md">
            <p-floatlabel variant="on">
              <input
                pInputText
                id="signatureName"
                formControlName="name"
                [maxlength]="100"
                fluid
                autocomplete="off"
                [invalid]="(signatureForm.get('name')?.invalid ?? false) && (signatureForm.get('name')?.touched ?? false)"
              />
              <label for="signatureName">Nombre de la firma <span class="text-red-500">*</span></label>
            </p-floatlabel>
            @if (signatureForm.get('name')?.hasError('required') && signatureForm.get('name')?.touched) {
              <small class="text-red-600">El nombre es requerido</small>
            }
          </div>

          @if (showTextImageFields()) {
            <div class="space-y-5" [formGroup]="fieldsForm">
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
                <div class="space-y-4 min-w-0">
                  <div class="rounded-xl border border-slate-200 overflow-hidden bg-white">
                    <div class="px-3 py-2 border-b border-slate-200 bg-slate-50/80">
                      <h4 class="text-sm font-semibold text-slate-800">Texto</h4>
                      <p class="text-xs text-slate-500 mt-0.5">Redacta el contenido con el editor. Se mostrará arriba de la imagen.</p>
                    </div>
                    <div class="signature-body-editor">
                      <p-editor formControlName="bodyHtml" [style]="bodyEditorStyle">
                        <ng-template pTemplate="header">
                          <span class="ql-formats">
                            <button type="button" class="ql-bold" aria-label="Negrita"></button>
                            <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                            <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                          </span>
                          <span class="ql-formats">
                            <select class="ql-color" aria-label="Color de texto"></select>
                          </span>
                          <span class="ql-formats">
                            <button type="button" class="ql-list" [attr.value]="'bullet'" aria-label="Lista"></button>
                            <button type="button" class="ql-link" aria-label="Enlace"></button>
                          </span>
                        </ng-template>
                      </p-editor>
                    </div>
                  </div>

                  <div class="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
                    <div class="flex items-start gap-4">
                      <div class="h-28 w-36 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-white flex items-center justify-center">
                        @if (fieldsForm.get('signImageUrl')?.value) {
                          <img
                            [src]="fieldsForm.get('signImageUrl')?.value"
                            alt="Imagen de firma"
                            class="h-full w-full object-contain p-1"
                          />
                        } @else {
                          <i class="pi pi-image text-slate-300 text-2xl"></i>
                        }
                      </div>
                      <div class="min-w-0 flex-1">
                        <h4 class="text-sm font-semibold text-slate-800">Imagen</h4>
                        <p class="text-xs text-slate-500 mt-0.5 mb-3">
                          Se sube al bucket público en <span class="font-mono">companies/{{ companyId() }}/signs/</span>
                        </p>
                        <div class="flex flex-wrap gap-2">
                          <label class="inline-flex">
                            <input
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                              class="hidden"
                              [disabled]="uploadingSignImage()"
                              (change)="onSignImageFileSelect($event)"
                            />
                            <span
                              class="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 cursor-pointer"
                              [class.opacity-60]="uploadingSignImage()"
                              [class.pointer-events-none]="uploadingSignImage()"
                            >
                              <i [class]="uploadingSignImage() ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"></i>
                              {{ uploadingSignImage() ? 'Subiendo…' : (fieldsForm.get('signImageUrl')?.value ? 'Cambiar imagen' : 'Subir imagen') }}
                            </span>
                          </label>
                          @if (fieldsForm.get('signImageUrl')?.value) {
                            <p-button
                              label="Quitar"
                              icon="pi pi-times"
                              severity="secondary"
                              [text]="true"
                              size="small"
                              type="button"
                              (onClick)="removeSignImage()"
                            />
                          }
                        </div>

                        <div class="mt-4 pt-3 border-t border-slate-200">
                          <p class="text-xs font-medium text-slate-600 mb-2">Tamaño</p>
                          <div class="grid grid-cols-2 gap-3">
                            <div class="flex flex-col gap-1">
                              <label class="text-[11px] text-slate-500" for="sigImageWidth">Ancho (px)</label>
                              <input
                                pInputText
                                id="sigImageWidth"
                                type="number"
                                formControlName="signImageWidth"
                                [min]="signImageWidthMin"
                                [max]="signImageWidthMax"
                                class="font-mono text-sm"
                                (change)="onSignImageWidthChange()"
                                (blur)="onSignImageWidthChange()"
                              />
                            </div>
                            <div class="flex flex-col gap-1">
                              <label class="text-[11px] text-slate-500" for="sigImageHeight">Alto</label>
                              <div
                                id="sigImageHeight"
                                class="flex h-[2.5rem] items-center gap-2 rounded-md border border-slate-200 bg-slate-100 px-3 text-sm text-slate-500"
                                title="El alto se ajusta automáticamente para conservar la proporción"
                              >
                                <i class="pi pi-lock text-xs" aria-hidden="true"></i>
                                <span>Auto</span>
                              </div>
                            </div>
                          </div>
                          <p class="text-[11px] text-slate-400 mt-2">
                            Rango {{ signImageWidthMin }}–{{ signImageWidthMax }} px. El alto crece proporcional al ancho.
                          </p>
                          <input
                            type="range"
                            class="mt-2 w-full accent-sky-600"
                            formControlName="signImageWidth"
                            [min]="signImageWidthMin"
                            [max]="signImageWidthMax"
                            step="10"
                            (input)="onSignImageWidthChange()"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 signature-preview-panel min-w-0 lg:sticky lg:top-0">
                  <p class="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 shrink-0">Vista previa</p>
                  <div class="rounded-lg border border-slate-200 bg-white p-4 signature-preview-scroll signature-preview-body" [innerHTML]="previewSafeHtml()"></div>
                  <div class="mt-4 shrink-0">
                    <p-button
                      label="Editar HTML"
                      icon="pi pi-code"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      type="button"
                      (onClick)="unlockFreeEdit()"
                    />
                  </div>
                </div>
              </div>
            </div>
          } @else if (showClassicFields()) {
            <div class="space-y-5" [formGroup]="fieldsForm">
              <div class="rounded-xl border border-slate-200 overflow-hidden bg-white">
                <div class="px-3 py-2 border-b border-slate-200 bg-slate-50/80">
                  <h4 class="text-sm font-semibold text-slate-800">Texto superior</h4>
                  <p class="text-xs text-slate-500 mt-0.5">Disclaimer, datos de empresa u otro texto libre que aparecerá arriba de la firma.</p>
                </div>
                <div class="signature-intro-editor">
                  <p-editor formControlName="introHtml" [style]="introEditorStyle">
                    <ng-template pTemplate="header">
                      <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Negrita"></button>
                        <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                        <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color" aria-label="Color de texto"></select>
                      </span>
                      <span class="ql-formats">
                        <button type="button" class="ql-list" [attr.value]="'bullet'" aria-label="Lista"></button>
                        <button type="button" class="ql-link" aria-label="Enlace"></button>
                      </span>
                    </ng-template>
                  </p-editor>
                </div>
              </div>

              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 content-start min-w-0">
                <div class="sm:col-span-2 rounded-lg border border-sky-100 bg-sky-50/70 px-3 py-2 text-xs text-sky-900">
                  <span class="font-medium">Datos del remitente:</span>
                  nombre, cargo, teléfono, email y foto se guardan como variables Handlebars y se resuelven al enviar.
                  Aquí solo ajustas la vista previa.
                </div>
                <div class="flex flex-col gap-1 sm:col-span-2">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigFullName" formControlName="fullName" fluid autocomplete="off" />
                    <label for="sigFullName">Nombre completo (vista previa)</label>
                  </p-floatlabel>
                  <small class="text-[11px] text-slate-400 font-mono">{{ '{{' + userVars.fullName + '}}' }}</small>
                </div>

                @if (showPhotoField()) {
                  <div class="sm:col-span-2 rounded-xl border border-slate-200 bg-slate-50/70 p-3">
                    <div class="flex items-center gap-3">
                      <div class="h-16 w-16 shrink-0 overflow-hidden rounded-full border border-slate-200 bg-white flex items-center justify-center">
                        @if (profilePhotoUrl()) {
                          <img [src]="profilePhotoUrl()" alt="Foto de perfil" class="h-full w-full object-cover" />
                        } @else {
                          <i class="pi pi-user text-slate-300 text-xl"></i>
                        }
                      </div>
                      <div class="min-w-0">
                        <h4 class="text-sm font-semibold text-slate-800">Foto de perfil</h4>
                        <p class="text-xs text-slate-500 mt-0.5">
                          @if (profilePhotoUrl()) {
                            Se usa automáticamente tu foto de perfil. Cámbiala desde tu perfil de usuario.
                          } @else {
                            No tienes foto de perfil; se mostrarán tus iniciales. Sube una foto desde tu perfil.
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                }

                @if (showLogoField()) {
                  <div class="sm:col-span-2 rounded-xl border border-slate-200 bg-slate-50/70 p-3">
                    <div class="flex items-center gap-3">
                      <div class="h-16 w-16 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-white flex items-center justify-center">
                        @if (companyLogoUrl()) {
                          <img [src]="companyLogoUrl()" alt="Logo de empresa" class="h-full w-full object-contain p-1" />
                        } @else {
                          <i class="pi pi-image text-slate-300 text-xl"></i>
                        }
                      </div>
                      <div class="min-w-0">
                        <h4 class="text-sm font-semibold text-slate-800">Logo de empresa</h4>
                        <p class="text-xs text-slate-500 mt-0.5">
                          @if (companyLogoUrl()) {
                            Se usa automáticamente el logo de la empresa. Cámbialo en la pestaña Generales.
                          } @else {
                            No hay logo cargado; se mostrará la inicial de la empresa. Súbelo en Generales.
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                }

                <div class="flex flex-col gap-1">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigJobTitle" formControlName="jobTitle" fluid autocomplete="off" />
                    <label for="sigJobTitle">Cargo (vista previa)</label>
                  </p-floatlabel>
                  <small class="text-[11px] text-slate-400 font-mono">{{ '{{' + userVars.jobTitle + '}}' }}</small>
                </div>
                <div class="flex flex-col gap-1">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigCompanyName" formControlName="companyName" fluid autocomplete="off" />
                    <label for="sigCompanyName">Empresa</label>
                  </p-floatlabel>
                </div>
                <div class="flex flex-col gap-1">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigEmail" formControlName="email" fluid autocomplete="off" />
                    <label for="sigEmail">Email (vista previa)</label>
                  </p-floatlabel>
                  <small class="text-[11px] text-slate-400 font-mono">{{ '{{' + userVars.email + '}}' }}</small>
                </div>
                <div class="flex flex-col gap-1">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigPhone" formControlName="phone" fluid autocomplete="off" />
                    <label for="sigPhone">Teléfono (vista previa)</label>
                  </p-floatlabel>
                  <small class="text-[11px] text-slate-400 font-mono">{{ '{{' + userVars.phone + '}}' }}</small>
                </div>
                <div class="flex flex-col gap-1 sm:col-span-2">
                  <p-floatlabel variant="on">
                    <input pInputText id="sigWebsite" formControlName="website" fluid autocomplete="off" />
                    <label for="sigWebsite">Sitio web</label>
                  </p-floatlabel>
                </div>
                <div class="flex flex-col gap-1 sm:col-span-2">
                  <label class="text-xs font-medium text-slate-600 mb-1" for="sigAccentColor">Color de acento</label>
                  <div class="flex items-center gap-3">
                    <input
                      id="sigAccentColor"
                      type="color"
                      formControlName="accentColor"
                      class="h-10 w-14 cursor-pointer rounded border border-slate-200 bg-white p-1"
                    />
                    <input pInputText formControlName="accentColor" class="flex-1 font-mono text-sm" maxlength="7" />
                  </div>
                </div>

                <div class="sm:col-span-2 mt-2 pt-3 border-t border-slate-200">
                  <div class="mb-3">
                    <h4 class="text-sm font-semibold text-slate-800">Redes sociales</h4>
                    <p class="text-xs text-slate-500 mt-0.5">Completa la URL para mostrar el logo en la firma. Déjalo vacío para ocultarlo.</p>
                  </div>
                  <div class="space-y-3">
                    @for (network of socialNetworks; track network.id) {
                      <div class="flex items-center gap-3">
                        <span
                          class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white"
                          [title]="network.label"
                        >
                          <img [src]="network.iconUrl" [alt]="network.label" width="18" height="18" class="block" />
                        </span>
                        <p-floatlabel class="flex-1 min-w-0" variant="on">
                          <input
                            pInputText
                            [id]="'sigSocial_' + network.id"
                            [formControlName]="network.field"
                            [placeholder]="network.placeholder"
                            fluid
                            autocomplete="off"
                          />
                          <label [for]="'sigSocial_' + network.id">{{ network.label }}</label>
                        </p-floatlabel>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 signature-preview-panel min-w-0 lg:sticky lg:top-0">
                <p class="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 shrink-0">Vista previa</p>
                <div class="rounded-lg border border-slate-200 bg-white p-4 signature-preview-scroll signature-preview-body" [innerHTML]="previewSafeHtml()"></div>
                <div class="mt-4 shrink-0">
                  <p-button
                    label="Editar HTML"
                    icon="pi pi-code"
                    severity="secondary"
                    [outlined]="true"
                    size="small"
                    type="button"
                    (onClick)="unlockFreeEdit()"
                  />
                </div>
              </div>
              </div>
            </div>
          } @else {
            <div class="grid grid-cols-1 lg:grid-cols-5 gap-4 items-start">
              <div class="lg:col-span-3 rounded-xl border border-slate-200 overflow-hidden bg-white min-w-0">
                <div class="signature-editor-shell" [class.html-mode]="editorHtmlMode()">
                  <p-editor
                    [style]="editorStyle"
                    (onInit)="onEditorInit($event)"
                    (onTextChange)="onEditorContentChange()"
                  >
                    <ng-template pTemplate="header">
                      <span class="ql-formats">
                        <select class="ql-header" aria-label="Encabezado"></select>
                      </span>
                      <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Negrita"></button>
                        <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                        <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color" aria-label="Color de texto"></select>
                      </span>
                      <span class="ql-formats">
                        <button type="button" class="ql-link" aria-label="Enlace"></button>
                      </span>
                      <span class="ql-formats pento-html-source-formats">
                        <button
                          type="button"
                          class="pento-html-source-toggle"
                          [class.ql-active]="editorHtmlMode()"
                          aria-label="Modo HTML"
                          title="Modo HTML"
                          (click)="toggleEditorHtmlMode($event)"
                        >&lt;&gt;</button>
                      </span>
                    </ng-template>
                  </p-editor>
                  @if (editorHtmlMode()) {
                    <textarea
                      #signatureHtmlSource
                      class="editor-html-source"
                      spellcheck="false"
                      [(ngModel)]="editorHtmlSource"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onEditorHtmlSourceChange()"
                    ></textarea>
                  }
                </div>
              </div>
              <div class="lg:col-span-2 rounded-xl border border-slate-200 bg-slate-50/60 p-4 signature-preview-panel min-w-0 lg:sticky lg:top-0">
                <p class="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 shrink-0">Vista previa</p>
                <div class="rounded-lg border border-slate-200 bg-white p-4 signature-preview-scroll signature-preview-body min-h-40" [innerHTML]="previewSafeHtml()"></div>
                <p class="text-xs text-slate-500 mt-3 shrink-0">
                  El HTML del template se conserva aquí. Si sales del modo <span class="font-mono">&lt;&gt;</span> al editor visual, Quill puede simplificar tablas y estilos.
                </p>
              </div>
            </div>
          }
        </div>

        <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-slate-200 shrink-0 sticky bottom-0 bg-white">
          <p-button label="Cancelar" severity="secondary" type="button" (onClick)="closeEditor()" />
          <p-button
            [label]="editingId() ? 'Guardar cambios' : 'Crear firma'"
            icon="pi pi-check"
            type="button"
            (onClick)="saveSignature()"
          />
        </div>
      }
      </div>
    </div>
  </div>
}

@if (deleteConfirmOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <div
      class="absolute inset-0 bg-black transition-opacity duration-200"
      [class.bg-opacity-40]="deleteConfirmShown()"
      [class.bg-opacity-0]="!deleteConfirmShown()"
      (click)="closeDelete()"
    ></div>
    <div
      class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10 transform transition-all duration-200"
      [class.opacity-100]="deleteConfirmShown()"
      [class.opacity-0]="!deleteConfirmShown()"
      [class.scale-100]="deleteConfirmShown()"
      [class.scale-95]="!deleteConfirmShown()"
    >
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold text-slate-900">Eliminar firma</h3>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (onClick)="closeDelete()" />
      </div>
      <p class="text-sm text-slate-600 mb-6">
        ¿Eliminar la firma «{{ deleteItem()?.name }}»?
      </p>
      <div class="flex justify-end gap-3">
        <p-button label="Cancelar" severity="secondary" (onClick)="closeDelete()" />
        <p-button label="Eliminar" severity="danger" icon="pi pi-trash" (onClick)="confirmDelete()" />
      </div>
    </div>
  </div>
}
